import { apiBaseUrl } from 'constants/apiBaseUrl'
import { getAuthToken } from 'core/api/axiosClient'

export type AssistantModelOption = {
  id: string
  label: string
  costHint: string
  inputPer1M: number | null
  outputPer1M: number | null
  /** Blended (in+out) cost vs the cheapest approved model. 1 = cheapest. */
  relativeCost: number | null
}

export type AssistantModelsResponse = {
  models: AssistantModelOption[]
  defaultModel: string
  selected: string
  budget: {
    spentUsd: number
    capUsd: number
    remainingUsd: number
    capReached: boolean
    blocked: boolean
  }
}

export async function fetchAssistantModels(): Promise<AssistantModelsResponse> {
  const token = await getAuthToken()
  const response = await fetch(`${apiBaseUrl}/portal/admin/assistant/models`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!response.ok) throw new Error(`Could not load models (${response.status})`)
  return (await response.json()) as AssistantModelsResponse
}
